(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5208],{

/***/ 39989:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/account/downloadable-products",
      function () {
        return __webpack_require__(12458);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 93487:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(29815);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(81043);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _svg__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(69587);
/* harmony import */ var _store_token__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(46607);
/* harmony import */ var _api_shop__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(65564);
/* harmony import */ var _store_cart__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(7597);
/* harmony import */ var _account_module_scss__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(67707);
/* harmony import */ var _account_module_scss__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(_account_module_scss__WEBPACK_IMPORTED_MODULE_14__);
/* harmony import */ var _store_customer__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(97331);
/* harmony import */ var _hooks_useGlobal__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(76210);
/* harmony import */ var _shared_PageHeader__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(64465);
/* harmony import */ var _store_wishlist__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(84444);
/* harmony import */ var _AccountNavigationMenu__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(81111);
/* harmony import */ var _store_orders_ordersActions__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(64514);




















var AccountLayout = function(param) {
    var children = param.children, breadcrumb = param.breadcrumb, translationsData = param.translationsData, selectedLocale = param.selectedLocale, dbName = param.dbName;
    var selectedRate = (0,_hooks_useGlobal__WEBPACK_IMPORTED_MODULE_11__/* .useGlobal */ .O)().selectedRate;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)([]), links = ref[0], setLinks = ref[1];
    var history = (0,next_router__WEBPACK_IMPORTED_MODULE_5__.useRouter)();
    var dispatch = (0,react_redux__WEBPACK_IMPORTED_MODULE_4__/* .useDispatch */ .I0)();
    var cartToken = (0,react_redux__WEBPACK_IMPORTED_MODULE_4__/* .useSelector */ .v9)(function(state) {
        return state.cartToken;
    }).cartToken;
    var isDownloadableOrder = !!(0,react_redux__WEBPACK_IMPORTED_MODULE_4__/* .useSelector */ .v9)(function(state) {
        return state.orders.downloadable;
    }).length;
    var customer = (0,react_redux__WEBPACK_IMPORTED_MODULE_4__/* .useSelector */ .v9)(function(state) {
        return state.customer;
    });
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        var baseLinks = [
            {
                id: 1,
                url: "profile",
                icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_svg__WEBPACK_IMPORTED_MODULE_6__/* .Profile */ .NZ, {}),
                title: translationsData.PersonalInformation
            },
            {
                id: 2,
                url: "orders",
                icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_svg__WEBPACK_IMPORTED_MODULE_6__/* .Orders */ .We, {
                    className: (_account_module_scss__WEBPACK_IMPORTED_MODULE_14___default()["historyIcon-svg"])
                }),
                title: translationsData.MyOrders
            }
        ].concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z)(isDownloadableOrder ? [
            {
                id: 3,
                icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_svg__WEBPACK_IMPORTED_MODULE_6__/* .DownloadIcon */ ._8, {}),
                url: "downloadable-products",
                title: translationsData.DownloadableProducts
            }
        ] : []), [
            {
                id: 4,
                url: "addresses",
                icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_svg__WEBPACK_IMPORTED_MODULE_6__/* .Addresses */ .sA, {}),
                title: translationsData.Address
            },
            {
                id: 5,
                url: "logout",
                icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_svg__WEBPACK_IMPORTED_MODULE_6__/* .Logout */ .RD, {}),
                title: translationsData.SignOut
            }
        ]);
        setLinks(baseLinks);
    }, [
        isDownloadableOrder
    ]);
    var logout = function(e) {
        e.preventDefault();
        dispatch((0,_store_customer__WEBPACK_IMPORTED_MODULE_10__/* .setAuth */ .QV)(false));
        dispatch((0,_store_customer__WEBPACK_IMPORTED_MODULE_10__/* .setCustomerGroupID */ .KJ)(1));
        dispatch((0,_store_customer__WEBPACK_IMPORTED_MODULE_10__/* .setToken */ .o4)(""));
        dispatch((0,_store_orders_ordersActions__WEBPACK_IMPORTED_MODULE_16__/* .clearOrders */ .oh)());
        _api_shop__WEBPACK_IMPORTED_MODULE_8__["default"].getCustomerLogoutToken(customer.token).then(function(item) {
            if (item.ok) {
                _api_shop__WEBPACK_IMPORTED_MODULE_8__["default"].getCheckoutCartToken().then(function(res) {
                    if (res.api_token) {
                        dispatch((0,_store_token__WEBPACK_IMPORTED_MODULE_7__/* .AddCartToken */ .y)(res.api_token));
                    }
                });
            }
        });
        dispatch((0,_store_cart__WEBPACK_IMPORTED_MODULE_9__/* .getCartDataMount */ .yU)(cartToken, {
            token: ""
        }, selectedLocale, selectedRate ? selectedRate.code : ""));
        dispatch((0,_store_wishlist__WEBPACK_IMPORTED_MODULE_17__/* .wishListRemoveAllItems */ .XZ)());
        history.push("/");
    };
    var newLinks = links.map(function(link) {
        var classes = classnames__WEBPACK_IMPORTED_MODULE_2___default()((_account_module_scss__WEBPACK_IMPORTED_MODULE_14___default()["account-nav__item"]), history.route.includes(link.url) && (_account_module_scss__WEBPACK_IMPORTED_MODULE_14___default()["account-nav__item--active"]));
        var signOutProps = link.url === "logout" ? {
            onClick: logout,
            className: (_account_module_scss__WEBPACK_IMPORTED_MODULE_14___default().logout)
        } : {};
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
            className: classes,
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_3___default()), {
                href: "/account/".concat(link.url),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("a", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z)({}, signOutProps), {
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                            children: link.icon
                        }),
                        link.title
                    ]
                }))
            })
        }, link.id);
    });
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_shared_PageHeader__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {
                dbName: dbName,
                breadcrumb: breadcrumb
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
                className: (_account_module_scss__WEBPACK_IMPORTED_MODULE_14___default()["account-nav__title"]),
                children: translationsData.MyAccount
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: (_account_module_scss__WEBPACK_IMPORTED_MODULE_14___default().block),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "container",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: (_account_module_scss__WEBPACK_IMPORTED_MODULE_14___default()["account-layout-wrapper"]),
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_AccountNavigationMenu__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z, {
                                links: newLinks
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "".concat((_account_module_scss__WEBPACK_IMPORTED_MODULE_14___default()["account-layout"]), " ").concat((_account_module_scss__WEBPACK_IMPORTED_MODULE_14___default()["account-layout-desktop"])),
                                children: children
                            })
                        ]
                    })
                })
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (AccountLayout);


/***/ }),

/***/ 64465:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _svg__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(69587);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _shared_module_scss__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(12820);
/* harmony import */ var _shared_module_scss__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_shared_module_scss__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var next_script__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(4298);
/* harmony import */ var next_script__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(next_script__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _schemaorg__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(91257);








var PageHeader = function(props) {
    var _breadcrumb = props.breadcrumb, breadcrumb = _breadcrumb === void 0 ? [] : _breadcrumb, dbName = props.dbName;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_4__.useRouter)();
    var schema = (0,_schemaorg__WEBPACK_IMPORTED_MODULE_6__/* .schemaPageHeader */ .ed)(dbName, router.asPath, breadcrumb);
    if (breadcrumb.length > 0) {
        var lastIndex = breadcrumb.length - 1;
        breadcrumb = breadcrumb.map(function(item, index) {
            var link;
            if (lastIndex === index) {
                link = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_script__WEBPACK_IMPORTED_MODULE_5___default()), {
                            id: schema.name,
                            type: "application/ld+json",
                            dangerouslySetInnerHTML: {
                                __html: JSON.stringify(schema)
                            }
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                            className: "".concat((_shared_module_scss__WEBPACK_IMPORTED_MODULE_7___default()["breadcrumb-item"]), " ").concat((_shared_module_scss__WEBPACK_IMPORTED_MODULE_7___default()["breadcrumb-item-active"])),
                            "aria-current": "page",
                            children: item.title
                        })
                    ]
                }, index);
            } else {
                link = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("li", {
                    className: (_shared_module_scss__WEBPACK_IMPORTED_MODULE_7___default()["breadcrumb-item"]),
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
                            href: item.url,
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                children: item.title
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_svg__WEBPACK_IMPORTED_MODULE_3__/* .ArrowRoundedRight6x9Svg */ .EO, {
                            className: (_shared_module_scss__WEBPACK_IMPORTED_MODULE_7___default()["breadcrumb-arrow"])
                        })
                    ]
                }, index);
            }
            return link;
        });
        breadcrumb = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: (_shared_module_scss__WEBPACK_IMPORTED_MODULE_7___default()["page-header__breadcrumb"]),
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("nav", {
                "aria-label": "breadcrumb",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("ol", {
                    className: (_shared_module_scss__WEBPACK_IMPORTED_MODULE_7___default().breadcrumb),
                    children: breadcrumb
                })
            })
        });
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: (_shared_module_scss__WEBPACK_IMPORTED_MODULE_7___default()["page-header"]),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: "".concat((_shared_module_scss__WEBPACK_IMPORTED_MODULE_7___default()["page-header__container"]), " container"),
            children: breadcrumb
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (PageHeader);


/***/ }),

/***/ 76193:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(14924);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _shared_module_scss__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(12820);
/* harmony import */ var _shared_module_scss__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_shared_module_scss__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _svg__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(69587);






var Pagination = function(param) {
    var _current = param.current, current = _current === void 0 ? 1 : _current, _siblings = param.siblings, siblings = _siblings === void 0 ? 1 : _siblings, _total = param.total, total = _total === void 0 ? 1 : _total, onPageChange = param.onPageChange;
    var setPage = function(value) {
        if (value < 1 || value > total || value === current) {
            return;
        }
        try {
            window.scrollTo({
                top: 0,
                left: 0,
                behavior: "smooth"
            });
        } catch (e) {
            window.scrollTo(0, 0);
        }
        if (onPageChange) {
            onPageChange(value);
        }
    };
    var getPages = function() {
        var pages = [];
        var min = Math.max(1, current - siblings - Math.max(0, siblings - total + current));
        var max = Math.min(total, min + siblings * 2);
        for(var i = min; i <= max; i += 1){
            pages.push(i);
        }
        return pages;
    };
    var firstLinkClasses = classnames__WEBPACK_IMPORTED_MODULE_2___default()((_shared_module_scss__WEBPACK_IMPORTED_MODULE_4___default()["page-item"]), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, (_shared_module_scss__WEBPACK_IMPORTED_MODULE_4___default()["page-item-disabled"]), current <= 1));
    var lastLinkClasses = classnames__WEBPACK_IMPORTED_MODULE_2___default()((_shared_module_scss__WEBPACK_IMPORTED_MODULE_4___default()["page-item"]), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, (_shared_module_scss__WEBPACK_IMPORTED_MODULE_4___default()["page-item-disabled"]), current >= total));
    var pages = getPages().map(function(page, index) {
        var classes = classnames__WEBPACK_IMPORTED_MODULE_2___default()((_shared_module_scss__WEBPACK_IMPORTED_MODULE_4___default()["page-item"]), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, (_shared_module_scss__WEBPACK_IMPORTED_MODULE_4___default()["page-item-active"]), page === current));
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
            className: classes,
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("button", {
                type: "button",
                className: (_shared_module_scss__WEBPACK_IMPORTED_MODULE_4___default()["page-link"]),
                onClick: function() {
                    return setPage(page);
                },
                children: [
                    page,
                    page === current && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                        className: (_shared_module_scss__WEBPACK_IMPORTED_MODULE_4___default()["sr-only"]),
                        children: current
                    })
                ]
            })
        }, index);
    });
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("ul", {
        className: (_shared_module_scss__WEBPACK_IMPORTED_MODULE_4___default().pagination),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                className: firstLinkClasses,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                    type: "button",
                    className: "".concat((_shared_module_scss__WEBPACK_IMPORTED_MODULE_4___default()["page-link"]), " ").concat((_shared_module_scss__WEBPACK_IMPORTED_MODULE_4___default()["page-link--with-arrow"])),
                    "aria-label": "Previous",
                    onClick: function() {
                        return setPage(current - 1);
                    },
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_svg__WEBPACK_IMPORTED_MODULE_3__/* .ArrowRoundedLeft8x13Svg */ .lb, {
                        className: "".concat((_shared_module_scss__WEBPACK_IMPORTED_MODULE_4___default()["page-link__arrow"]), " ").concat((_shared_module_scss__WEBPACK_IMPORTED_MODULE_4___default()["page-link__arrow--left"])),
                        "aria-hidden": "true"
                    })
                })
            }),
            pages,
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                className: lastLinkClasses,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                    type: "button",
                    className: "".concat((_shared_module_scss__WEBPACK_IMPORTED_MODULE_4___default()["page-link"]), " ").concat((_shared_module_scss__WEBPACK_IMPORTED_MODULE_4___default()["page-link--with-arrow"])),
                    "aria-label": "Next",
                    onClick: function() {
                        return setPage(current + 1);
                    },
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_svg__WEBPACK_IMPORTED_MODULE_3__/* .ArrowRoundedRight8x13Svg */ .pn, {
                        className: "".concat((_shared_module_scss__WEBPACK_IMPORTED_MODULE_4___default()["page-link__arrow"]), " ").concat((_shared_module_scss__WEBPACK_IMPORTED_MODULE_4___default()["page-link__arrow--right"])),
                        "aria-hidden": "true"
                    })
                })
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Pagination);


/***/ }),

/***/ 76210:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "O": function() { return /* reexport safe */ _context_GlobalContext__WEBPACK_IMPORTED_MODULE_0__.b; }
/* harmony export */ });
/* harmony import */ var _context_GlobalContext__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(68912);



/***/ }),

/***/ 12458:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ downloadable_products; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./helper.js
var helper = __webpack_require__(63385);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./components/account/AccountLayout.tsx
var AccountLayout = __webpack_require__(93487);
// EXTERNAL MODULE: ./components/ForCWV/Wrappers/MainLayout.tsx + 29 modules
var MainLayout = __webpack_require__(84980);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 19 modules
var es = __webpack_require__(81043);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./components/account/account.module.scss
var account_module = __webpack_require__(67707);
var account_module_default = /*#__PURE__*/__webpack_require__.n(account_module);
// EXTERNAL MODULE: ./components/shared/Pagination.tsx
var Pagination = __webpack_require__(76193);
// EXTERNAL MODULE: ./svg/index.js
var svg = __webpack_require__(69587);
;// CONCATENATED MODULE: ./components/account/AccountPageDownloadableOrders.tsx










var AccountPageDownloadableOrders = function(param) {
    var dbName = param.dbName, translationsData = param.translationsData;
    var formatDate = function formatDate(date) {
        var cleared = date.split("-");
        var year = cleared[0];
        var month = cleared[1];
        var day = cleared[2].slice(0, 2);
        return day + "/" + month + "/" + year;
    };
    var customer = (0,es/* useSelector */.v9)(function(state) {
        return state.customer;
    });
    var limit = 10;
    var ref = (0,react.useState)(1), page = ref[0], setPage = ref[1];
    var ref1 = (0,react.useState)(true), okStatus = ref1[0], setOkStatus = ref1[1];
    var downloadableOrders = (0,es/* useSelector */.v9)(function(state) {
        return state.orders.downloadable;
    });
    var allLinks = downloadableOrders.flatMap(function(order) {
        return order.items.flatMap(function(item) {
            return item.downloadable_links.map(function(link) {
                return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, link), {
                    orderId: order.id,
                    createdAt: order.created_at
                });
            });
        });
    });
    var totalPages = Math.ceil(allLinks.length / limit);
    var paginatedLinks = allLinks.slice((page - 1) * limit, page * limit);
    var ref2 = (0,react.useState)(false), updateRequest = ref2[0], setUpdateRequest = ref2[1];
    var ref3 = (0,react.useState)(null), loaderIdCls = ref3[0], setLoaderIdCls = ref3[1];
    var api_token = (0,es/* useSelector */.v9)(function(state) {
        return state.cartToken.cartToken;
    });
    var handlePageChange = function(page) {
        setPage(page);
    };
    if (!downloadableOrders) return null;
    var orderStatusColor = function(status) {
        switch(status){
            case "closed":
                return "#D71313";
            case "expired":
                return "#4f46e5";
            case "pending":
                return "#f4ce14";
            case "available":
                return "#049901";
            default:
                return "#000";
        }
    };
    var ordersList = paginatedLinks.length > 0 ? paginatedLinks.map(function(dwnLink) {
        var statusIdKey = dwnLink === null || dwnLink === void 0 ? void 0 : dwnLink.status;
        var statusKey = statusIdKey[0].toUpperCase() + statusIdKey.slice(1);
        var dwnBought = dwnLink.download_bought;
        var downloadsQty = dwnLink.download_bought - dwnLink.download_used;
        var downloadAllow = (dwnBought === 0 || downloadsQty > 0) && statusIdKey === "available" && okStatus;
        var loaderClickHandle = function() {
            return setLoaderIdCls(dwnLink.id);
        };
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
            className: (account_module_default()).dwn_tr,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                    className: "".concat((account_module_default()).dwn_column, " ").concat((account_module_default()).dwn_link_column),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                        href: "/account/orders/".concat(dwnLink.orderId),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                            className: (account_module_default()).order__id,
                            children: "#".concat(dwnLink.orderId)
                        })
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                    className: "".concat((account_module_default()).dwn_column, " ").concat(downloadAllow ? (account_module_default()).dwn__active : null),
                    children: downloadAllow ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: dwnLink.product_name
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (account_module_default()).download__btn_container,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                        children: translationsData.Download
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                        className: (account_module_default()).download__btn,
                                        onClick: function() {
                                            setOkStatus(false);
                                            setUpdateRequest(!updateRequest);
                                        },
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                            target: "_blank",
                                            href: (0,helper/* domainUrl */.HJ)("".concat(dbName, "/api/downloadable-products/download/").concat(dwnLink.id, "?token=").concat(customer.token, "&api_token=").concat(api_token)),
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                onClick: loaderClickHandle,
                                                className: (account_module_default()).link_container,
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(svg/* DownloadCloudIcon */.ND, {})
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        children: dwnLink.name
                                                    })
                                                ]
                                            })
                                        })
                                    })
                                ]
                            })
                        ]
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (account_module_default()).disabled__product_name,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: dwnLink.product_name
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (account_module_default()).disabled__link_container,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                        children: translationsData.Download
                                    }),
                                    statusIdKey === "available" && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: loaderIdCls === dwnLink.id ? "btn-loading" : "",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(svg/* DownloadCloudIcon */.ND, {})
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        children: dwnLink.name
                                    })
                                ]
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                    className: (account_module_default()).dwn_column,
                    children: formatDate(dwnLink.createdAt)
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                    className: (account_module_default()).dwn_column,
                    style: {
                        color: orderStatusColor(statusIdKey.toLowerCase())
                    },
                    children: translationsData[statusKey]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                    className: (account_module_default()).dwn_column,
                    children: dwnBought === 0 ? translationsData === null || translationsData === void 0 ? void 0 : translationsData.UnlimitedTimes : downloadsQty
                })
            ]
        }, dwnLink.id);
    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
        className: (account_module_default()).empty_orders_list,
        children: translationsData.DownloadableListEmpty
    });
    var mobileOrderList = paginatedLinks.length > 0 ? paginatedLinks.map(function(dwnLink, index) {
        var loaderClickHandle = function() {
            return setLoaderIdCls(dwnLink.id);
        };
        var statusIdKey = dwnLink === null || dwnLink === void 0 ? void 0 : dwnLink.status;
        var statusKey = statusIdKey[0].toUpperCase() + statusIdKey.slice(1);
        var dwnBought = dwnLink.download_bought;
        var downloadsQty = dwnLink.download_bought - dwnLink.download_used;
        var downloadAllow = (dwnBought === 0 || downloadsQty > 0) && statusIdKey === "available" && okStatus;
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "".concat((account_module_default()).card, " ").concat((account_module_default())["order-history-card-mobile"]),
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (account_module_default())["order-card-mobile-top-position"],
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("table", {
                    className: (account_module_default()).mob_dwn_table,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("thead", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                className: (account_module_default()).dwn_first_column,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                        className: (account_module_default())["order-card-mobile-title"],
                                        style: {
                                            textTransform: "uppercase"
                                        },
                                        children: translationsData.OrderId
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                            href: "/account/orders/".concat(dwnLink.orderId),
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: (account_module_default())["order-id-mobile-href"],
                                                children: "#".concat(dwnLink.orderId)
                                            })
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                        className: (account_module_default())["order-card-mobile-title"],
                                        children: translationsData.Product
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                        className: (account_module_default()).downloads_column_mob,
                                        children: downloadAllow ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: (account_module_default()).downloads__container,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    className: (account_module_default()).dw__product_name,
                                                    children: dwnLink.product_name
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: (account_module_default()).download__btn_container,
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                                            children: translationsData.Download
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                                            className: (account_module_default()).download__btn,
                                                            onClick: function() {
                                                                return setUpdateRequest(!updateRequest);
                                                            },
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                target: "_blank",
                                                                href: (0,helper/* domainUrl */.HJ)("".concat(dbName, "/api/downloadable-products/download/").concat(dwnLink.id, "?token=").concat(customer.token, "&api_token=").concat(api_token)),
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                    onClick: loaderClickHandle,
                                                                    className: (account_module_default()).link_container,
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(svg/* DownloadCloudIcon */.ND, {})
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                            children: dwnLink.name
                                                                        })
                                                                    ]
                                                                })
                                                            })
                                                        })
                                                    ]
                                                })
                                            ]
                                        }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: (account_module_default()).disabled__product_name,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    children: dwnLink.product_name
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: (account_module_default()).disabled__link_container,
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                                            children: translationsData.Download
                                                        }),
                                                        statusIdKey === "available" && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: loaderIdCls === dwnLink.id ? "btn-loading" : "",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(svg/* DownloadCloudIcon */.ND, {})
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                            children: dwnLink.name
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                        children: translationsData.Date
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                        children: formatDate(dwnLink.createdAt)
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                        children: translationsData.Status
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                        style: {
                                            color: orderStatusColor(statusIdKey.toLowerCase())
                                        },
                                        children: translationsData[statusKey]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                        children: translationsData.RemainingDownloads
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                        className: (account_module_default()).dwn_column,
                                        children: dwnBought === 0 ? translationsData === null || translationsData === void 0 ? void 0 : translationsData.UnlimitedTimes : downloadsQty
                                    })
                                ]
                            })
                        ]
                    })
                })
            })
        }, dwnLink.id);
    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
        className: (account_module_default()).empty_orders_list,
        children: translationsData.DownloadableListEmpty
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (account_module_default()).card_desktop,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (account_module_default()).card,
                        children: downloadableOrders.length > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (account_module_default())["card-table"],
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("table", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("thead", {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                                    children: translationsData.OrderId
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                                    children: translationsData.Name
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                                    children: translationsData.Date
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                                    children: translationsData.Status
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                                    children: translationsData.RemainingDownloads
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("tbody", {
                                        children: ordersList
                                    })
                                ]
                            })
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: (account_module_default()).empty_orders_list,
                            children: translationsData.DownloadableListEmpty
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (account_module_default())["card-footer"],
                        children: totalPages > 1 && /*#__PURE__*/ (0,jsx_runtime.jsx)(Pagination/* default */.Z, {
                            current: page,
                            total: totalPages,
                            onPageChange: handlePageChange
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (account_module_default()).card_mobile,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (account_module_default())["orders-page-mobile"],
                        children: mobileOrderList
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (account_module_default())["card-footer"],
                        children: totalPages > 1 && /*#__PURE__*/ (0,jsx_runtime.jsx)(Pagination/* default */.Z, {
                            current: page,
                            total: totalPages,
                            onPageChange: handlePageChange
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var account_AccountPageDownloadableOrders = (AccountPageDownloadableOrders);

;// CONCATENATED MODULE: ./pages/account/downloadable-products.tsx











var DownloadableProducts = function(pageProps) {
    var dbName = pageProps.dbName, selectedLocale = pageProps.selectedLocale, translationsData = pageProps.translationsData, breadcrumb = pageProps.breadcrumb, defaultLangCode = pageProps.defaultLangCode, locales = pageProps.locales;
    var customer = (0,es/* useSelector */.v9)(function(state) {
        return state.customer;
    });
    var router = (0,next_router.useRouter)();
    var meta_title = "My Personal Account";
    var meta_description = "My Personal Account for ".concat(dbName, " website ");
    var meta_keywords = "";
    var meta_url = (0,helper/* domainUrl */.HJ)("".concat(dbName).concat(router.locale !== "catchAll" && router.locale !== defaultLangCode ? "/" + selectedLocale : "").concat(router.asPath));
    (0,react.useEffect)(function() {
        if (!customer.token && !customer.authenticated) {
            router.push("/").then(function(r) {
                return r;
            });
        }
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(MainLayout/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, pageProps), {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)((head_default()), {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                            children: meta_title
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                            name: "title",
                            content: meta_title
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                            name: "description",
                            content: meta_description
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                            name: "keywords",
                            content: meta_keywords
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                            name: "generator",
                            content: "Zegashop.com"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                            name: "twitter:description",
                            content: meta_description
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                            name: "twitter:title",
                            content: meta_title
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                            property: "og:description",
                            content: meta_description
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                            property: "og:title",
                            content: meta_title
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                            property: "og:keywords",
                            content: meta_keywords
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                            property: "og:url",
                            content: meta_url
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                            property: "og:locale",
                            content: selectedLocale
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                            rel: "canonical",
                            href: meta_url
                        }),
                        (locales === null || locales === void 0 ? void 0 : locales.length) > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                                    rel: "alternate",
                                    href: (0,helper/* domainUrl */.HJ)("".concat(dbName).concat(router.asPath)),
                                    hrefLang: "x-default"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                                    rel: "alternate",
                                    href: (0,helper/* domainUrl */.HJ)("".concat(dbName).concat(router.asPath)),
                                    hrefLang: defaultLangCode
                                }),
                                locales.map(function(intl) {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                                        rel: "alternate",
                                        href: (0,helper/* domainUrl */.HJ)("".concat(dbName, "/").concat(intl.code).concat(router.asPath)),
                                        hrefLang: intl.code
                                    });
                                })
                            ]
                        }) : null
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(AccountLayout/* default */.Z, {
                    dbName: dbName,
                    breadcrumb: breadcrumb,
                    translationsData: translationsData,
                    selectedLocale: selectedLocale,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(account_AccountPageDownloadableOrders, {
                        translationsData: translationsData,
                        dbName: dbName
                    })
                })
            ]
        })
    }));
};
var __N_SSP = true;
/* harmony default export */ var downloadable_products = (DownloadableProducts);


/***/ }),

/***/ 12820:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"line__active":"shared_line__active___ydao","under_line__active":"shared_under_line__active__TzH_Z","text-success":"shared_text-success__b_GSc","text-danger":"shared_text-danger__uaRO3","product__prices":"shared_product__prices__CVW7b","color-lightgray":"shared_color-lightgray__tr4MM","product-card__new-price":"shared_product-card__new-price__Uh_wK","product-card__new-price_old_value":"shared_product-card__new-price_old_value__lZEg1","product-card__old-price":"shared_product-card__old-price__qVzw5","test":"shared_test__XJFgh","slick-prevent-click":"shared_slick-prevent-click__46Rz_","product-gallery__carousel":"shared_product-gallery__carousel__rweRi","slick-list":"shared_slick-list__Qm8q0","slick-track":"shared_slick-track__e1on5","product__gallery":"shared_product__gallery__2Qcoo","product-gallery__featured":"shared_product-gallery__featured__7qvkg","product-image__body":"shared_product-image__body___pMPQ","product-image":"shared_product-image__RGE_Z","product-gallery__zoom":"shared_product-gallery__zoom__zE4Rt","product-gallery__carousel-item":"shared_product-gallery__carousel-item__YOaGt","product-image--location--gallery":"shared_product-image--location--gallery__mX462","product-image__img":"shared_product-image__img__7FiK4","owl-carousel":"shared_owl-carousel__DZ_qV","owl-item":"shared_owl-item__1Ipyt","product-gallery__carousel-item--active":"shared_product-gallery__carousel-item--active__Y6uRZ","small-img-car_fms":"shared_small-img-car_fms__trqT1","product-small-img":"shared_product-small-img__19vI8","currency_value":"shared_currency_value__5IPjM","block-header":"shared_block-header__Y47R6","block-header__title":"shared_block-header__title__fNPSo","block-header__divider":"shared_block-header__divider__z_Ltc","block-header__groups-list":"shared_block-header__groups-list__Lcx3T","block-header__title__custom":"shared_block-header__title__custom__sD_wp","title-line-fms":"shared_title-line-fms__G_D1_","title-name-fms":"shared_title-name-fms__dTBlZ","block-header__group":"shared_block-header__group__wwwXx","block-header__group--active":"shared_block-header__group--active__Fl3KN","block-header__arrows-list":"shared_block-header__arrows-list__Acux7","block-header__arrow":"shared_block-header__arrow__IeFTb","block-header__arrow--left":"shared_block-header__arrow--left__UKyJW","block-header__arrow--right":"shared_block-header__arrow--right__KMu9G","breadcrumb":"shared_breadcrumb___jX19","minus_hide":"shared_minus_hide__G0BFC","input-number__input":"shared_input-number__input__pZxDP","input-number__sub":"shared_input-number__sub__8I6_b","input-number__add":"shared_input-number__add__0lk8a","form-control-sm":"shared_form-control-sm__fiyvR","product__quantity":"shared_product__quantity__j3dv_","cart-quantity-responsive":"shared_cart-quantity-responsive__5_4kx","page-header":"shared_page-header__36R5E","breadcrumb-item":"shared_breadcrumb-item__0qre7","breadcrumb-item-active":"shared_breadcrumb-item-active__V3KYS","page-header__breadcrumb":"shared_page-header__breadcrumb__i_Z7a","page-header__title":"shared_page-header__title__JaRFr","breadcrumb-arrow":"shared_breadcrumb-arrow__uQK9o","page-header__container":"shared_page-header__container__mEt_Q","pagination":"shared_pagination__bdXo7","sr-only":"shared_sr-only__9FqOD","page-link":"shared_page-link__CMUmq","page-link--with-arrow":"shared_page-link--with-arrow__c1IUc","page-link__arrow":"shared_page-link__arrow__mULrQ","page-link__arrow--left":"shared_page-link__arrow--left___61oN","page-link__arrow--right":"shared_page-link__arrow--right__k9sB2","page-item":"shared_page-item__dpA_F","page-item-disabled":"shared_page-item-disabled__DERIG","page-item-active":"shared_page-item-active__MPK7e","bottomNavigation-wrapper":"shared_bottomNavigation-wrapper__qch5s","indicatpr_area":"shared_indicatpr_area__8uOGn","bottom-nav-item--title":"shared_bottom-nav-item--title__vcuz0","bottom-nav-item--title-active":"shared_bottom-nav-item--title-active__XLHhd","local-item":"shared_local-item__lM6aT","local-item-active":"shared_local-item-active__SLCm2","active":"shared_active__9Ifpg","bottom-nav-item":"shared_bottom-nav-item__O_XHs","bottom-nav":"shared_bottom-nav__H2kJw","indicator__value":"shared_indicator__value__WOLbt","indicator":"shared_indicator__H_FQK","false":"shared_false___CPLZ","indicator__area":"shared_indicator__area__th4gv","mob_area":"shared_mob_area___TbbM","block-posts":"shared_block-posts___KdlJ","slick-slide":"shared_slick-slide__A6TQC","post-card":"shared_post-card__iG54_","block-posts--layout--list-sm":"shared_block-posts--layout--list-sm__U1MbP","post-card__image":"shared_post-card__image__7N_gj","post-card__name":"shared_post-card__name__mtEZ3","post-card__date":"shared_post-card__date__Vl_uC","post-card__category":"shared_post-card__category__tfnxa","post-card__content":"shared_post-card__content__WkHA7","post-card__read-more":"shared_post-card__read-more__8ZXB_","post-card__info":"shared_post-card__info__hGWgj","block-posts--layout--grid-nl":"shared_block-posts--layout--grid-nl__A6c3z","post-card__read-data":"shared_post-card__read-data__D4d0W","post-card--layout--related":"shared_post-card--layout--related__XefJD","post-card--layout--grid":"shared_post-card--layout--grid__e3_ld","post-card--size--lg":"shared_post-card--size--lg__x_1XA","post-card--layout--list":"shared_post-card--layout--list__wvqDN","post-card--size--nl":"shared_post-card--size--nl__AJ2H2","post-card--size--sm":"shared_post-card--size--sm__6Zwvl","social-links__list":"shared_social-links__list__dfW3w","social-links__item":"shared_social-links__item__7uXma","social-links__link":"shared_social-links__link__b_S9g","social-links--shape--circle":"shared_social-links--shape--circle__YFFEi","social-links--shape--rounded":"shared_social-links--shape--rounded__TT0YX","social-links__link--type--facebook":"shared_social-links__link--type--facebook__G719K","social-links__link--type--twitter":"shared_social-links__link--type--twitter__7ulYd","social-links__link--type--youtube":"shared_social-links__link--type--youtube__FWKHG","social-links__link--type--instagram":"shared_social-links__link--type--instagram___32Vy","social-links__link--type--rss":"shared_social-links__link--type--rss___vbZg","wishlist-circle":"shared_wishlist-circle__IHvkp","wishlist-icon-wrapper":"shared_wishlist-icon-wrapper__pW_9v","wishlist-circle-clicked":"shared_wishlist-circle-clicked__ZBHpI","inner-wishlist":"shared_inner-wishlist__S07T4","product-card__prices":"shared_product-card__prices__OXbim","uPsell-title":"shared_uPsell-title__TIb25","upsell_body":"shared_upsell_body__5qzyA","product__content":"shared_product__content__zHVz_","product__info":"shared_product__info__2JUdC","short_description_block":"shared_short_description_block__hIkfU","product-inner-description-title":"shared_product-inner-description-title__h9vAb","product__meta":"shared_product__meta__EwL40","product__sidebar":"shared_product__sidebar__O9bRJ","product__options":"shared_product__options__2X85W","product__actions":"shared_product__actions__dAK_0","no-thanks":"shared_no-thanks__G__wn","btn":"shared_btn__2IzVc","btn-orange":"shared_btn-orange__zc5e3","rounded-pills":"shared_rounded-pills__Z7qlr","product__name":"shared_product__name__QUTXW","ups-product__info":"shared_ups-product__info__W_YrR","item_overlay":"shared_item_overlay__qz1Am","product-card__image":"shared_product-card__image__IroED","cross__prods":"shared_cross__prods__xJAFI","input-number":"shared_input-number__mS_oj","product-image__default-fms":"shared_product-image__default-fms__0xjYL","product__actions-item--addToCart":"shared_product__actions-item--addToCart__dHUJi"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [3061,7838,7992,3997,9774,2888,179], function() { return __webpack_exec__(39989); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);